import { _x } from '@wordpress/i18n'
import { useConfigContext } from './ConfigContext'

export default function NoResults() {
  const { contactUrl, emptyText } = useConfigContext()

  return (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: '15%'
      }}
      className="d-flex flex-column justify-content text-center py-4"
    >
      {/* Custom text from the block settings replaces title and hint */}
      <h3 className="display-3" style={{ whiteSpace: 'pre-line' }}>
        {emptyText || _x('No event found', 'Events List No Results Title', 'icf')}
      </h3>
      {!emptyText && (
        <p style={{ paddingLeft: '20%', paddingRight: '20%' }}>
          {_x(
            "We will be happy to help finding the right one for you. Let's talk about it.",
            'Events List No Results Text',
            'icf'
          )}
        </p>
      )}
      <div className="mt-4">
        <a href={contactUrl} className="btn btn-default">
          {_x('Contact us', 'Events List No Results Contact Button', 'icf')}
        </a>
      </div>
    </div>
  )
}
